export const isSupportedOrNullish = (property) => property === undefined || property === null || property.IsSupported;